import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { closeDrawer, getURLSegment } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

// Dependencies
import moment from 'moment';

// Components
import BlackoutList from '../BlackoutDates/BlackoutList';

const ScheduleInstructor = observer(class ScheduleInstructor extends React.Component {
  constructor() {
    super();
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.selectTime = this.selectTime.bind(this);
    this.changeTime = this.changeTime.bind(this);
    this.createAppointment = this.createAppointment.bind(this);
  }

  componentWillMount() {
    let times = [];

    this.props.store.ExamStore.exam.configuration.instructorAsProctor.forEach(function(session){
      times.push(null);
    });

    this.state = {
      step: 1,
      times,
      examSid: null,
      sessionSid: null,
      appointmentStartDate: null,
      instructorProctorSid: null
    }

    if(!this.props.reschedule && !this.props.skipUrl) {
      this.setState({
        examSid: getURLSegment(this, 3),
        sessionSid: getURLSegment(this, 5)
      })
    } else {
      this.setState({
        examSid: this.props.examSid,
        sessionSid: this.props.sessionSid
      })
    }

    this.props.store.SessionStore.getCurrentTime();
  }

  nextStep(e) {
    if(e) {
      e.preventDefault();
    }

    this.setState({
      step: this.state.step + 1
    }, function(){
      // Hide the close button on the last step so the
      // student has to click the return to dashboard button
      if(this.state.step === 3) {
        this.props.store.SessionStore.hideDrawerClose = true;
      }
    });
  }

  prevStep() {
    this.setState({
      step: this.state.step - 1
    });
  }

  statusClass(step) {
    if(this.state.step === step) {
      return 'slide-active';
    } else if(this.state.step > step) {
      return 'slide-hidden-before';
    } else {
      return 'slide-hidden-after';
    }
  }

  selectTime(i, startTime, isRange, sid) {
    const { userTimezone } = this.props.store.SessionStore;

    this.setState({
      instructorProctorSid: sid
    });

    if(isRange) {
      const date = moment(startTime).tz(userTimezone).format('YYYY-MM-DD Z');
      const time = this[`time${i}`].value;
      const formattedTime = moment(`${date} ${time}`, 'YYYY-MM-DD Z HH:mm').toISOString();

      if(time) {
        this.setState({
          appointmentStartDate: formattedTime
        })
      } else {
        this.setState({
          appointmentStartDate: null
        })
      }
    } else {
      this.setState({
        appointmentStartDate: startTime
      });

      const _this = this;

      setTimeout(function(){
        _this.nextStep()
      });
    }
  }

  changeTime() {
    this.setState({
      appointmentStartDate: null,
      instructorProctorSid: null
    });

    const timeSelects = document.querySelectorAll('.instructor-time');

    for(let i = 0; i < timeSelects.length; i++) {
      timeSelects[i].value = '';
    }

    const _this = this;

    setTimeout(function(){
      _this.prevStep();
    })
  }

  createAppointment() {
    const { ScheduleStore } = this.props.store;

    const data = {
      type: 'instructor-as-proctor',
      appointmentDateTime: this.state.appointmentStartDate,
      instructorProctorSid: this.state.instructorProctorSid
    }

    ScheduleStore.createAppointment(this.state.examSid, this.state.sessionSid, data, () => {this.nextStep(null)});
  }

  renderTimes(startTime, endTime) {
    const { userTimezone } = this.props.store.SessionStore;
    const startHour = parseInt(moment.utc(startTime).tz(userTimezone).format('H'), 10);
    const startMinute = parseInt(moment.utc(startTime).tz(userTimezone).format('m'), 10);
    const endHour = parseInt(moment.utc(endTime).tz(userTimezone).format('H'), 10);
    const endMinute = parseInt(moment.utc(endTime).tz(userTimezone).format('m'), 10);
    const timeDiff = endHour - startHour;

    let options = [];

    for(let i = 0; i <= timeDiff; i++) {
      let hour = startHour + i;
      let ampm = 'am';

      if(hour > 12) {
        hour -= 12;
        ampm = 'pm';
      } else if(hour === 12) {
        ampm = 'pm';
      }

      const hourOption = React.createElement('option', { key: `${i}-hour`, value: `${startHour + i}:00` }, `${hour}:00${ampm}`);

      const halfOption = React.createElement('option', { key: `${i}-half`, value: `${startHour + i}:30` }, `${hour}:30${ampm}`);

      if(i !== 0 || startMinute !== 30) {
        options.push(hourOption);
      }

      if(startHour + i !== endHour || endMinute === 30) {
        options.push(halfOption);
      }
    }

    let optgroup = React.createElement('optgroup', null, options);

    return optgroup;
  }

  hideEmptyTable(dateOpts) {
    let table = document.querySelector('.iap-dates');

    setTimeout(function(){
      if(dateOpts === 0 && table) {
        table.className += ' hidden';
      } else if(dateOpts > 0 && table) {
        table.className = table.className.replace('hidden', '');
      }
    });
  }

  render() {
    const { translation } = this.props;
    const { examSession } = this.props.store.ExamStore;
    const { StudentStore } = this.props.store;
    const { userTimezone } = this.props.store.SessionStore;
    let dateOpts = 0;

    return(
      <div className="drawer__content">
        <header className="drawer__header">
          <div className="wrap">
            <h1 className="drawer__title">{translation.intro.heading}</h1>
          </div>
        </header>

        <div className="slide-wrap wrap">
          <BlackoutList {...this.props} />

          <div className={`${this.statusClass(1)}`}>
            <table className="iap-dates">
              <thead>
                <tr>
                  <th scope="col"><span className="meta">{translation.date}</span></th>
                  <th scope="col"><strong className="subtitle">{translation.time}</strong></th>
                  <th scope="col"><strong className="subtitle">{translation.location}</strong></th>
                  <th scope="col"><strong className="subtitle">{translation.actions}</strong></th>
                </tr>
              </thead>
              <tbody>
                {examSession.examConfiguration.instructorAsProctor.map(
                  (key, i) => {
                    let now = moment(this.props.store.SessionStore.currentTime);
                    let endDate = null;

                    if(key.endTime) {
                      endDate = moment(key.endTime).tz(userTimezone);
                    } else {
                      endDate = moment(key.startTime).tz(userTimezone);
                    }

                    let endDiff = moment.duration(endDate.diff(now)).asHours();

                    if(endDiff > 0) {
                      dateOpts++;

                      return (
                        <tr key={i}>
                          <th scope="row">
                            <strong>{moment.utc(key.startTime).tz(userTimezone).format('dddd, MMMM D')}</strong>
                          </th>
                          <td>
                            {key.endTime &&
                              <span>
                                {moment.utc(key.startTime).tz(userTimezone).format('h:mma')}–
                                {moment.utc(key.endTime).tz(userTimezone).format('h:mma z')}
                              </span>
                            }

                            {!key.endTime &&
                              <span>{moment.utc(key.startTime).tz(userTimezone).format('h:mma z')}</span>
                            }
                          </td>
                          <td className="addr">
                            <p>{key.location}</p>
                          </td>
                          {key.endTime &&
                            <td className="actions">
                              <label className="select select--sm" htmlFor={`time-${i}`}>
                                <select
                                  id={`time-${i}`}
                                  className="instructor-time"
                                  ref={(input) => {this[`time${i}`] = input}}
                                  onChange={() => {this.selectTime(i, key.startTime, true, key.sid)}}
                                  disabled={this.state.appointmentStartDate && !this[`time${i}`].value}
                                >
                                  <option value="">{translation.time}</option>
                                  {this.renderTimes(key.startTime, key.endTime)}
                                </select>
                              </label>

                              <button
                                className="btn--outline"
                                disabled={!this.state.appointmentStartDate || !this[`time${i}`].value}
                                onClick={(e) => {this.nextStep()}}
                              >
                                {translation.button}
                              </button>
                            </td>
                          }

                          {!key.endTime &&
                            <td className="actions">
                              <button
                                className="btn--outline btn--full"
                                onClick={() => {this.selectTime(i, key.startTime, false, key.sid)}}
                              >
                                {translation.button}
                              </button>
                            </td>
                          }
                        </tr>
                      )
                    }
                    return null;
                  }
                )}
              </tbody>
            </table>

            {this.hideEmptyTable(dateOpts)}

            {dateOpts === 0 &&
              <span className="no-results">{translation.no_dates}</span>
            }
          </div>

          <div className={`panel panel--brief ${this.statusClass(2)}`}>
            <h2 className="panel__title">{translation.confirm.heading}</h2>

            <p>{translation.confirm.body_pre}</p>

            <time className="text-code">
              {moment(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
            </time>

            <p>{translation.confirm.body_post}</p>

            <button className="btn" onClick={this.createAppointment}>
              <icons.iconCalendarPlus />
              {translation.confirm.button}
            </button>

            <span className="preposition--vertical">{translation.confirm.or}</span>

            <button
              className="btn--link"
              onClick={this.changeTime}
            >
              {translation.confirm.change_time}
            </button>
          </div>

          <div className={`panel panel--brief ${this.statusClass(3)}`}>
            <h2 className="panel__title">{translation.confirmed.heading}!</h2>

            <p>{translation.confirmed.body}</p>

            <time dateTime="2017-03-06t00:00" className="text-code">
              {moment(this.state.appointmentStartDate).tz(userTimezone).format('dddd, MMMM D [at] h:mma z')}
            </time>

            <a
              className="btn btn--icn-right"
              href="#app"
              onClick={(e) => {closeDrawer(e, this.props.parent, '/', StudentStore.getStudentExams)}}
            >
              {translation.confirmed.button}
              <icons.iconCircleRight />
            </a>
          </div>
        </div>
      </div>
    )
  }
})

export default translate('ScheduleInstructor')(ScheduleInstructor);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ScheduleInstructor.js